import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import 'src/style/createVehicleTracking.css';
import { ReactComponent as ArrowLeft } from 'src/Images/icons/common/arrowleft.svg';
import { ReactComponent as ArrowRight } from 'src/Images/icons/common/arrowright.svg';
import OutwardVehicleTrackingAttachDeliverySection from 'src/components/VehicleTrackingCreate/Outward/OutwardVehicleTrackingAttachDeliverySection';
import OutwardVehicleTrackingSelectedDocumentsSection from 'src/components/VehicleTrackingCreate/Outward/OutwardVehicleTrackingSelectedDocumentsSection';

function AttachDeliveryToVehicleTrackingPlanning({
  formData,
  selectedDeliveryOrder,
  setSelectedDeliveryOrder,
  handleOnChange,
  errorField,
  handleDeleteDeliveryOrder,
  selectedBusinessPartner,
  setSelectedBusinessPartner,
  deliveryFilters,
  setDeliveryFilters,
}) {
  const authReducer = useSelector((state) => state.AuthReducer);
  const themeColor = authReducer?.userData?.tenant?.theme;
  const [showSelectedDocuments, setShowSelectedDocuments] = useState(false);

  return (
    <div className="create-form-container">
      <Row className="g-0 create-form-row">
        <Col
          className={`theme-scrollable-container-${themeColor} scrollable-container selected-documents-main-col`}
        >
          <div className="col-container">
            {/* select delivery order card */}
            <OutwardVehicleTrackingAttachDeliverySection
              formData={formData}
              selectedDeliveryOrder={selectedDeliveryOrder}
              setSelectedDeliveryOrder={setSelectedDeliveryOrder}
              handleOnChange={handleOnChange}
              selectedBusinessPartner={selectedBusinessPartner}
              setSelectedBusinessPartner={setSelectedBusinessPartner}
              deliveryFilters={deliveryFilters}
              setDeliveryFilters={setDeliveryFilters}
            />
          </div>
        </Col>
        <Col
          className={`selected-documents-drawer-col ${
            showSelectedDocuments
              ? 'selected-documents-drawer-expanded'
              : 'selected-documents-drawer-collapsed'
          }`}
        >
          {!showSelectedDocuments && (
            <button
              type="button"
              className="selected-documents-edge-btn"
              onClick={() =>
                setShowSelectedDocuments((currentValue) => !currentValue)
              }
              aria-label="Show selected documents"
              title="Show Selected Documents"
            >
              <ArrowLeft className="icon-size-sm" />
            </button>
          )}
          {showSelectedDocuments && (
            <div className="selected-documents-expanded-card">
              <OutwardVehicleTrackingSelectedDocumentsSection
                selectedDeliveryOrder={selectedDeliveryOrder}
                errorField={errorField}
                handleDeleteDeliveryOrder={handleDeleteDeliveryOrder}
                titlePrefix={
                  <button
                    type="button"
                    className="selected-documents-inline-btn"
                    onClick={() =>
                      setShowSelectedDocuments((currentValue) => !currentValue)
                    }
                    aria-label="Hide selected documents"
                    title="Hide Selected Documents"
                  >
                    <ArrowRight className="icon-size-sm" />
                  </button>
                }
              />
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
}

export default AttachDeliveryToVehicleTrackingPlanning;
